import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="194.673"
      height="67.335"
      version="1.2"
      viewBox="0 0 292.01 101.002"
    >
      <defs>
        <filter
          id="alpha"
          width="1"
          height="1"
          x="0"
          y="0"
          filterUnits="objectBoundingBox"
        >
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          ></feColorMatrix>
        </filter>
        <image
          id="image539"
          width="293"
          height="102"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASUAAABmCAIAAAACvhBWAAAABmJLR0QA/wD/AP+gvaeTAAAAbUlEQVR4nO3BAQEAAACCIP+vbkhAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALwZerwABAdXzWAAAAABJRU5ErkJggg=="
        ></image>
        <mask id="mask0">
          <g filter="url(#alpha)">
            <use transform="translate(-4 -4)" xlinkHref="#image539"></use>
          </g>
        </mask>
        <image
          id="image535"
          width="49"
          height="65"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAABBCAYAAAB4vkzdAAAABmJLR0QA/wD/AP+gvaeTAAAAz0lEQVRoge3auwkCYRBF4bPrmIhgB2YimNl/YiMmdmCq+AhkKxhh7j/cr4I5yO5lwQn4MLi5+oB/cIQKR6hwhApHqHCECkeocISKFhEBPIBL8R0Z5wBewLX6koRDABOwq74kYR38vrHv1ZckPANYAfvqSxI2Ld5OjlDhCBXL2N2qD0k4eexEeOxkOEJFi4gA3gz+dmrzS7TYiRaLPTN4RItnwhEqWkR47FR47ER47GQ4QkWLCI+dCo+dCI+dDEeoWJ6JY/UhCdsJ/2tfQ4uILz3OISk/g+ljAAAAAElFTkSuQmCC"
        ></image>
        <mask id="mask1">
          <g filter="url(#alpha)">
            <use transform="translate(-3 -16)" xlinkHref="#image535"></use>
          </g>
        </mask>
        <clipPath id="clip3">
          <path d="M23 1h19.352v17H23zm0 0"></path>
        </clipPath>
        <clipPath id="clip4">
          <path d="M35 .965h7.352V6H35zm0 0"></path>
        </clipPath>
        <clipPath id="clip5">
          <path d="M20 42h11v4.598H20zm0 0"></path>
        </clipPath>
        <clipPath id="clip6">
          <path d="M1 36h9v10.598H1zm0 0"></path>
        </clipPath>
        <clipPath id="clip7">
          <path d="M.957 25H21v18H.957zm0 0"></path>
        </clipPath>
        <clipPath id="clip2">
          <path d="M0 0H43V47H0z"></path>
        </clipPath>
        <g id="surface534" clipPath="url(#clip2)">
          <path
            fill="#009FE3"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M15.613 7.855l-13.8-4.664.73 1.5 5.238 11.434-6.39-2.074-.172-12.86 11.75.133zm0 0"
          ></path>
          <g clipPath="url(#clip3)" clipRule="nonzero">
            <path
              fill="#009FE3"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M42.352 13.613l-.133 3.602-13.047-4.762-5.336-11.422 5.629.043 1.765.79 6.176 2.097zm0 0"
            ></path>
          </g>
          <g clipPath="url(#clip4)" clipRule="nonzero">
            <path
              fill="#009FE3"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M37.754 4.18L35.969.965l6.125.226.066 4.239zm0 0"
            ></path>
          </g>
          <g clipPath="url(#clip5)" clipRule="nonzero">
            <path
              fill="#009FE3"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M30.95 46.352l-8.903.246-1.621-3.602zm0 0"
            ></path>
          </g>
          <path
            fill="#009FE3"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M21.797 21.531l5.719 12.106-12.95-4.414-5.699-12.118zm0 0"
          ></path>
          <path
            fill="#009FE3"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M41.43 39.07c-.2.723-1.653 3.004-3.52 4.524-1.742 1.418-3.914 2.11-3.914 2.11l-5.46-10.923zm0 0"
          ></path>
          <path
            fill="#009FE3"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M41.984 27.719s-.695 9.86-.695 10.199L35.43 25.77zm0 0"
          ></path>
          <path
            fill="#009FE3"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M28.89 13.09l5.5 11.633-11.831-4.047h-.008L17.066 9.05l11.817 4.039zm0 0"
          ></path>
          <g clipPath="url(#clip6)" clipRule="nonzero">
            <path
              fill="#009FE3"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6.352 38.043l3.57 8.059s-4.168-.957-6.043-3.461c-.871-1.172-2.547-3.645-2.406-5.094.027-.277.234-.883.234-.883zm0 0"
            ></path>
          </g>
          <g clipPath="url(#clip7)" clipRule="nonzero">
            <path
              fill="#009FE3"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M20.934 42.98L6.352 38.043.957 26.086l.648-.863 12.907 4.636zm0 0"
            ></path>
          </g>
        </g>
        <clipPath id="clip8">
          <path d="M.707.703h47.848v64.012H.707zm0 0"></path>
        </clipPath>
        <clipPath id="clip1">
          <path d="M0 0H49V65H0z"></path>
        </clipPath>
        <g id="surface538" clipPath="url(#clip1)">
          <use
            mask="url(#mask1)"
            transform="translate(3 16)"
            xlinkHref="#surface534"
          ></use>
          <path
            fill="#009FE3"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M44.313 51.172a9.73 9.73 0 01-.106 1.484 7.722 7.722 0 01-.14.797 9.184 9.184 0 01-.126.547l-.074.25c-.05.176-.11.348-.168.516-.043.125-.082.25-.133.363l-.023.05-.05.118a10.802 10.802 0 01-6.333 5.965c-.164.066-.332.117-.496.168-.11.03-.219.062-.324.09l-.2.05-.19.04c-.575.124-1.16.206-1.77.242h-.29l-.242.007H15.492l-.246-.007h-.184a11.55 11.55 0 01-1.769-.243l-.055-.015-.324-.074c-.094-.028-.191-.051-.285-.083a5.014 5.014 0 01-.672-.222 10.783 10.783 0 01-6.207-5.918l-.055-.168a7.335 7.335 0 01-.316-.879L5.313 54a7.722 7.722 0 01-.208-.938c-.027-.097-.035-.199-.05-.296a9.59 9.59 0 01-.075-.7 7.42 7.42 0 01-.043-.894V40.914l-.007-10.18v-12.87h39.383zM3.852 16.793v2.723l.007 10.851v20.805c0 .176 0 .348.016.52.008.124.008.257.016.39-.008.02-.008.027 0 .043.011.066.02.133.027.2 0 .042.008.09.016.14.007.066.015.133.027.21.066.548.172 1.087.312 1.598l.075.266c.101.344.218.664.343.996l.063.168a11.808 11.808 0 006.879 6.54c.308.116.633.214.949.288.016.008.031.008.047.016l.41.101c.207.051.363.082.488.11l.149.023c.043 0 .074.008.117.016.398.066.812.11 1.227.125l.175.008.266.008h18.332c.246-.008.496-.016.746-.032.164-.015.324-.035.48-.05a4.036 4.036 0 00.301-.044l.297-.046a8.6 8.6 0 00.457-.094c.04 0 .09-.016.133-.024h.008l.398-.101c.164-.04.34-.09.504-.14.168-.048.332-.098.5-.165.192-.066.383-.14.574-.222.563-.243 1.11-.528 1.633-.852.176-.105.34-.215.508-.328.164-.117.332-.235.488-.356.48-.375.938-.78 1.352-1.222v-.008c.422-.441.805-.91 1.144-1.41.118-.168.235-.332.332-.508.325-.523.614-1.07.848-1.633l.066-.168a.408.408 0 00.032-.097s0-.008.011-.02c.024-.047.04-.105.067-.172.047-.14.09-.281.14-.426.016-.062.032-.136.06-.207.007-.004.007-.023.015-.031.008-.016.008-.023.015-.043.024-.082.051-.172.075-.266.273-.976.414-2.023.414-3.101v-7.719l.011-9.75v-16.91zm0 0"
          ></path>
          <g clipPath="url(#clip8)" clipRule="nonzero">
            <path
              fill="#1D1D1B"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M6.855 60.547a11.631 11.631 0 01-3.757-8.586l-.012-34.695V15.87h43.07l-.008 36.074c0 6.461-5.238 11.707-11.71 11.707l-17.07.016h-2.563c-2.184 0-4.223-.598-5.977-1.64a10.895 10.895 0 01-1.973-1.481M47.996 1.633l.02-.028-.36-.347a1.898 1.898 0 00-2.68 0l-3.808 3.816a2.185 2.185 0 00-.29.375 2.61 2.61 0 00-.28-.375l-3.82-3.816a1.898 1.898 0 00-2.68 0L30.28 5.074c-.11.11-.191.215-.265.324a2.674 2.674 0 00-.258-.324l-3.824-3.816a1.888 1.888 0 00-2.672 0l-3.817 3.816a2.77 2.77 0 00-.265.324c-.07-.109-.16-.214-.258-.324l-3.817-3.816a1.912 1.912 0 00-2.69 0l-3.81 3.816c-.109.11-.19.215-.265.324a2.08 2.08 0 00-.258-.324L4.266 1.258a1.898 1.898 0 00-2.68 0l-.348.347.008.028c-.34.39-.539.894-.539 1.449 0 1.027 1.434 2.14 1.336 3.8l-.008 8.169v14.867l.008 22.043c0 7.035 5.707 12.754 12.762 12.754h16.191c.192 0 .371 0 .555-.02h2.887c7.046 0 12.753-5.707 12.753-12.75l.008-36.687c0-.028.012-.051.012-.082V6.883c-.117-1.66 1.344-2.774 1.344-3.801 0-.555-.215-1.059-.559-1.45"
            ></path>
          </g>
          <path
            fill="#fff"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M3.09 3.95l.262-.259a.21.21 0 000-.296l-.262-.258a.205.205 0 00-.293 0l-.258.258a.21.21 0 000 .296l.258.258a.205.205 0 00.293 0m2.469 2.899l.253-.262c.09-.082.09-.207 0-.293l-.253-.262a.212.212 0 00-.293 0l-.258.262a.205.205 0 000 .293l.258.262c.082.078.21.078.293 0m19.207-2.899l.257-.258a.21.21 0 000-.296l-.257-.258a.215.215 0 00-.301 0l-.254.258a.226.226 0 000 .296l.254.258a.215.215 0 00.3 0m-2.464 2.899l.254-.262a.205.205 0 000-.293l-.254-.262a.222.222 0 00-.301 0l-.254.262a.205.205 0 000 .293l.254.262a.222.222 0 00.3 0m4.93 0l.258-.262a.212.212 0 000-.293l-.258-.262a.212.212 0 00-.293 0l-.257.262a.205.205 0 000 .293l.258.262a.212.212 0 00.292 0m8.368-2.899l.265-.258a.226.226 0 000-.296l-.265-.258a.2.2 0 00-.29 0l-.261.258a.21.21 0 000 .296l.262.258a.2.2 0 00.289 0m-2.461 2.899l.258-.262a.22.22 0 000-.293l-.258-.262a.222.222 0 00-.301 0l-.254.262a.205.205 0 000 .293l.254.262a.222.222 0 00.3 0m4.93 0l.258-.262a.212.212 0 000-.293l-.258-.262a.217.217 0 00-.296 0l-.254.262a.205.205 0 000 .293l.254.262a.217.217 0 00.296 0m-24.14-2.899l.261-.258a.21.21 0 000-.296l-.261-.258a.205.205 0 00-.293 0l-.254.258a.203.203 0 000 .296l.254.258a.205.205 0 00.293 0M11.46 6.848l.262-.262a.22.22 0 000-.293l-.262-.262a.212.212 0 00-.293 0l-.254.262a.205.205 0 000 .293l.254.262a.212.212 0 00.293 0m4.934 0l.261-.262a.205.205 0 000-.293l-.261-.262a.217.217 0 00-.297 0l-.254.262a.205.205 0 000 .293l.254.262a.217.217 0 00.297 0m30.039-2.899l.261-.258a.217.217 0 000-.296l-.261-.258a.2.2 0 00-.29 0l-.261.258a.203.203 0 000 .296l.262.258a.2.2 0 00.289 0m-2.461 2.899l.257-.262a.212.212 0 000-.293l-.257-.262a.222.222 0 00-.301 0l-.258.262a.212.212 0 000 .293l.258.262a.222.222 0 00.3 0m-8.195 6.457l.567-.567a.474.474 0 000-.656l-.567-.566a.47.47 0 00-.652 0l-.57.566a.467.467 0 000 .656l.57.567c.184.18.469.18.652 0m-10.84 0l.57-.567a.474.474 0 000-.656l-.57-.566a.465.465 0 00-.648 0l-.566.566a.46.46 0 000 .656l.566.567c.176.18.469.18.648 0m-10.84 0l.575-.567a.474.474 0 000-.656l-.574-.566a.465.465 0 00-.649 0l-.562.566a.467.467 0 000 .656l.562.567c.184.18.473.18.649 0m-4.485-.446v-.843c0-.266-.3-.485-.675-.485H7.753c-.379 0-.68.219-.68.485v.843c0 .27.301.485.68.485h1.18c.379 0 .68-.215.68-.485m10.84 0v-.843c0-.266-.302-.485-.684-.485h-1.184c-.375 0-.676.219-.676.485v.843c0 .27.3.485.676.485h1.184c.382 0 .683-.215.683-.485m10.836 0v-.843c0-.266-.309-.485-.684-.485h-1.18c-.378 0-.679.219-.679.485v.843c0 .27.3.485.68.485h1.18c.374 0 .683-.215.683-.485m10.836 0v-.843c0-.266-.305-.485-.68-.485h-1.183c-.375 0-.68.219-.68.485v.843c0 .27.305.485.68.485h1.183c.375 0 .68-.215.68-.485m-30.496-.277v-.367a.207.207 0 00-.211-.207h-.363a.208.208 0 00-.207.207v.367c0 .113.093.211.207.211h.363a.21.21 0 00.21-.211m4.942.203l.254-.254a.21.21 0 000-.297l-.254-.254c-.09-.085-.218-.085-.3 0l-.258.254a.217.217 0 000 .297l.258.254c.082.086.21.086.3 0m5.895-.203v-.367a.21.21 0 00-.211-.207h-.36a.21.21 0 00-.21.207v.367c0 .113.093.211.21.211h.36c.117 0 .21-.098.21-.211m5.177.004v-.371a.214.214 0 00-.211-.207h-.371a.208.208 0 00-.207.207v.37c0 .114.093.208.207.208h.37c.11 0 .212-.094.212-.207m5.43.2l.253-.255a.203.203 0 000-.297l-.254-.254a.208.208 0 00-.3 0l-.258.254a.21.21 0 000 .297l.258.254a.208.208 0 00.3 0m5.403-.2v-.37a.207.207 0 00-.211-.207h-.367c-.11 0-.2.094-.2.207v.37c0 .114.09.208.2.208h.367c.12 0 .21-.094.21-.207m5.426.2l.262-.255a.21.21 0 000-.297l-.262-.254a.199.199 0 00-.293 0l-.261.254a.226.226 0 000 .297l.261.254a.199.199 0 00.293 0m-38.296 0l.257-.254a.203.203 0 000-.297l-.257-.254a.194.194 0 00-.29 0l-.261.254a.21.21 0 000 .297l.261.254c.083.086.211.086.29 0m34.476-2.539l-.496-.488a.665.665 0 010-.926l.809-.797a.637.637 0 01.914 0l.812.797a.658.658 0 010 .926l-.492.488h3.055a1.114 1.114 0 01.152-1.062l.738-.907-.785-.785-.406.414a.771.771 0 01-1.078 0l-.93-.941a.754.754 0 010-1.07l.93-.938a.771.771 0 011.078 0l.3.305.673-.672-.52-.516a.771.771 0 010-1.078l.941-.937a.757.757 0 011.067 0l.625.625c.015.12.027.246.027.375 0 1.02-1.433 2.136-1.336 3.789v5.082l-.011 2.16c0 .39-.317.707-.7.707H3.785a.703.703 0 01-.7-.707V6.848c.11-1.653-1.335-2.77-1.335-3.79 0-.12.016-.234.027-.347l.649-.652a.762.762 0 011.07 0l.942.937a.764.764 0 010 1.078l-.532.528.672.668.313-.313a.776.776 0 011.082 0l.93.938a.754.754 0 010 1.07l-.93.941a.776.776 0 01-1.082 0l-.418-.43-.79.782.755.926c.234.289.28.718.148 1.062H7.57l-.492-.488a.658.658 0 010-.926l.805-.797a.641.641 0 01.918 0l.808.797c.25.258.25.668 0 .926l-.496.488h3.063c-.13-.344-.082-.773.152-1.062l.738-.907-.789-.785-.41.414a.766.766 0 01-1.074 0l-.934-.941a.754.754 0 010-1.07l.934-.938a.766.766 0 011.074 0l.301.305.672-.672-.512-.516c-.3-.3-.3-.781 0-1.078l.934-.937a.762.762 0 011.07 0l.941.937a.771.771 0 010 1.078l-.53.528.671.668.313-.313a.771.771 0 011.078 0l.933.938c.301.293.301.777 0 1.07l-.933.941a.771.771 0 01-1.078 0l-.422-.43-.785.782.753.926c.23.289.282.718.149 1.062h2.988l-.496-.488a.658.658 0 010-.926l.809-.797a.637.637 0 01.914 0l.808.797a.65.65 0 010 .926l-.496.488h3.063c-.13-.344-.082-.773.152-1.062l.738-.907-.785-.785-.41.414a.766.766 0 01-1.074 0l-.938-.941a.754.754 0 010-1.07l.938-.938a.766.766 0 011.074 0l.3.305.677-.672-.52-.516a.764.764 0 010-1.078l.934-.937a.766.766 0 011.074 0l.933.937c.301.297.301.777 0 1.078l-.53.528.675.668.316-.313a.766.766 0 011.075 0l.941.938a.762.762 0 010 1.07l-.941.941a.766.766 0 01-1.075 0l-.425-.43-.786.782.75.926c.235.289.282.718.153 1.062h2.984l-.496-.488a.665.665 0 010-.926l.809-.797a.641.641 0 01.918 0l.808.797a.658.658 0 010 .926l-.496.488h3.059c-.13-.344-.078-.773.152-1.062l.742-.907-.785-.785-.41.414a.771.771 0 01-1.078 0l-.93-.941a.748.748 0 010-1.07l.93-.938a.771.771 0 011.078 0l.3.305.673-.672-.52-.516a.779.779 0 010-1.078l.938-.937a.771.771 0 011.078 0l.933.937a.764.764 0 010 1.078l-.535.528.676.668.312-.313a.771.771 0 011.079 0l.933.938c.3.293.3.777 0 1.07l-.933.941a.771.771 0 01-1.079 0l-.421-.43-.782.782.75.926c.23.289.285.718.149 1.062zm0 0"
          ></path>
          <path
            fill="#1D1D1B"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M37.395 40.723l-11.836-4.051h-.008l-5.485-11.625 11.817 4.043h.008zm6.363 13.437L31.89 50.102 26.18 38l11.843 4.043zm-26.192-8.937l-5.699-12.118 12.93 4.426 5.715 12.106zM5.793 20.176l12.895 4.398 5.476 11.63-12.926-4.427zm39.61 13.527V32.59l-12.766-4.356-5.418-11.441h-1.16l5.203 10.969-11.809-4.024-3.289-6.945h-1.152l3.054 6.473L3.852 18.41v1.106l.539.18 5.453 11.6-5.977-2.042-.008 1.113 6.614 2.266 5.691 12.113-11.227-3.832-1.078-.363v1.07l12.938 4.45 5.601 11.898-12.902-4.375L3.86 41.637v2.554l1.079 2.25 3.21 6.707-4.273-1.453h-.008c.008.18.008.274.028.387-.012.02-.012.027 0 .043l.023.2c0 .042.008.09.016.14l.023.207 4.75 1.629 3.875 8.23.008.016c.172.043.324.074.45.101a8.696 8.696 0 00.636.133l.125.024-.008-.008-3.75-8.024 12.945 4.446 1.742 3.718h1.16l-1.519-3.242 9.41 3.242h.008c.25-.007.5-.015.75-.03.164-.016.324-.036.48-.052.098-.015.2-.027.301-.042l.297-.047a8.6 8.6 0 00.457-.094c.04 0 .09-.016.133-.024l-12.43-4.214-5.586-11.895 12.938 4.414h.008L36.14 61.57l.472.977c.164-.04.34-.09.504-.14.168-.048.332-.098.5-.165L32.523 51.43l11.848 4.039.191.066s.083-.222.11-.289c.047-.14.09-.281.14-.422.024-.078.141-.457.165-.547L39.41 42.523l5.985 2.043v-1.113L38.777 41.2 33.27 29.555zm0 0"
          ></path>
          <path
            fill="#1D1D1B"
            fillOpacity="1"
            fillRule="nonzero"
            stroke="none"
            d="M40.047 20.469L29.27 16.793c1.625-.012 2.714-.012 3.246-.012l6.91 2.367-1.121-2.355h1.164l1.343 2.82 4.583 1.57c.007.614.007 0 0 1.11l-3.961-1.352 3.96 8.364v2.449zm0 0"
          ></path>
        </g>
      </defs>
      <g>
        <use
          mask="url(#mask0)"
          transform="translate(4 4)"
          xlinkHref="#surface538"
        ></use>
        <path
          fill="#E30613"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M264.941 33.5h-7.964V18.098l7.964 5.632zm14.668 16.25V16.652L262.727 4.805 241.934 14.94v18.477h-7.23v14.98h7.23v3.09l-2.961-1.351-13.008 9.922 18.578 8.578 12.367-9.364V48.398h7.953l-.011 11.356 12.789 8.98 9.664-13.601zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M252.219 51.254h-5.985s1.078-1.152 2.996-1.152c1.907 0 2.989 1.152 2.989 1.152"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M253.07 52.79h-7.566v-.77h7.566zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M249.945 46.25v-1.508s.23.192.356.403a.78.78 0 01.043.609.925.925 0 01-.399.496m-3.46-6.156s.19.445.663.902c.696.691 1.743 1.402 2.348 1.836.64.465.996.738 1.395 1.113.355.328.629.739.746 1.102.093.3.117.723-.133 1.195-.5.938-1.559 1.438-1.559 1.438v-.723c0-.02.489-.242.82-.73.356-.532.231-1.106-.093-1.504-.23-.297-.602-.637-1.11-1.02-.48-.34-1.933-1.285-3.195-2.473-.238-.222-.297-.324-.508-.605-.214-.29-.355-.59-.53-.938 0 0 .655.29 1.155.407m1.852 8.199s-.848.445-1.27.93c0 0 .246-.95 1.27-1.602zm-6.906-10.074c1.27.754 2.316 1.07 2.965 1.3 0 0 .414 1.188 1.957 2.516.945.813 1.984 1.55 1.984 1.55v3.313s-.875.489-1.297 1.04c-.406.546-.863 1.277-.621 2.437 0 0 1.137-1.027 1.918-1.41v.754h.453v-5.86l.707.559v5.3h.45v-1.32s.554-.289 1.093-.726c.754-.61 1.203-1.43 1.277-2.102.067-.605-.28-1.453-1.136-2.23-.524-.477-1.235-1.031-1.235-1.031V40.75h-.449v1.254c-.531-.383-.348-.25-.707-.531v-.723h-.453v.398s-.524-.398-.824-.886c0 0 .699.105 1.691.105 1 0 3.356-.117 5.54-.957 2.171-.844 4.023-2.09 5.183-3.25h-21.227s.988 1.02 2.73 2.059"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M243.777 34.586s.211-1.363.5-2.16c.29-.797.621-1.852 1.676-2.953.82-.871 1.727-1.418 2.738-1.625 1.012-.211 2.325-.2 3.246.289.918.48 1.067.96 1.176 1.27 0 0-1.234-.88-2.304-1.063-.582-.102-2.036-.157-3.164.547-1.122.699-1.825 1.632-2.317 2.574-.488.937-.844 2.281-.918 3.12zm11.02-3.59l.043.531-.324-.28-.04-.481zm-9.61 3.57s.075-1.195.45-2.132c.367-.922.957-1.914 1.683-2.489 0 0 .375-.383 1.387-.761.695-.278 2.184-.368 3.262.414.68.488 1.129 1.375 1.27 1.66.175.347.706 1.375 1.218 2.082l.152-.117-.55-1.801 1.363 1.453s.031-.426-.067-1.008c-.05-.254-.117-.66-.25-1.066a6.855 6.855 0 00-.656-1.422c-.52-.852-1.379-1.656-2.894-2.09 0 0-1.77-.48-3.403-.016-1.629.45-2.773 1.579-3.277 2.34a11.42 11.42 0 00-1.488 3.168c-.29.996-.399 1.805-.399 1.805h-5.183v.77h23.011v-.77zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M249.945 46.25v-1.508s.23.192.356.403a.78.78 0 01.043.609.925.925 0 01-.399.496m-3.46-6.156s.19.445.663.902c.696.691 1.743 1.402 2.348 1.836.64.465.996.738 1.395 1.113.355.328.629.739.746 1.102.093.3.117.723-.133 1.195-.5.938-1.559 1.438-1.559 1.438v-.723c0-.02.489-.242.82-.73.356-.532.231-1.106-.093-1.504-.23-.297-.602-.637-1.11-1.02-.48-.34-1.933-1.285-3.195-2.473-.238-.222-.297-.324-.508-.605-.214-.29-.355-.59-.53-.938 0 0 .655.29 1.155.407m1.852 8.199s-.848.445-1.27.93c0 0 .246-.95 1.27-1.602zm-6.906-10.074c1.27.754 2.316 1.07 2.965 1.3 0 0 .414 1.188 1.957 2.516.945.813 1.984 1.55 1.984 1.55v3.313s-.875.489-1.297 1.04c-.406.546-.863 1.277-.621 2.437 0 0 1.137-1.027 1.918-1.41v.754h.453v-5.86l.707.559v5.3h.45v-1.32s.554-.289 1.093-.726c.754-.61 1.203-1.43 1.277-2.102.067-.605-.28-1.453-1.136-2.23-.524-.477-1.235-1.031-1.235-1.031V40.75h-.449v1.254c-.531-.383-.348-.25-.707-.531v-.723h-.453v.398s-.524-.398-.824-.886c0 0 .699.105 1.691.105 1 0 3.356-.117 5.54-.957 2.171-.844 4.023-2.09 5.183-3.25h-21.227s.988 1.02 2.73 2.059"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M243.777 34.586s.211-1.363.5-2.16c.29-.797.621-1.852 1.676-2.953.82-.871 1.727-1.418 2.738-1.625 1.012-.211 2.325-.2 3.246.289.918.48 1.067.96 1.176 1.27 0 0-1.234-.88-2.304-1.063-.582-.102-2.036-.157-3.164.547-1.122.699-1.825 1.632-2.317 2.574-.488.937-.844 2.281-.918 3.12zm11.02-3.59l.043.531-.324-.28-.04-.481zm-9.61 3.57s.075-1.195.45-2.132c.367-.922.957-1.914 1.683-2.489 0 0 .375-.383 1.387-.761.695-.278 2.184-.368 3.262.414.68.488 1.129 1.375 1.27 1.66.175.347.706 1.375 1.218 2.082l.152-.117-.55-1.801 1.363 1.453s.031-.426-.067-1.008c-.05-.254-.117-.66-.25-1.066a6.855 6.855 0 00-.656-1.422c-.52-.852-1.379-1.656-2.894-2.09 0 0-1.77-.48-3.403-.016-1.629.45-2.773 1.579-3.277 2.34a11.42 11.42 0 00-1.488 3.168c-.29.996-.399 1.805-.399 1.805h-5.183v.77h23.011v-.77zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M6.285 91.46h2.98c.512 0 .872-.019 1.079-.058.367-.062.672-.168.914-.316.25-.148.449-.367.605-.656.157-.285.239-.614.239-.989 0-.437-.118-.82-.34-1.14a1.83 1.83 0 00-.957-.684c-.407-.129-.989-.195-1.75-.195h-2.77zm0-5.425h2.59c.703 0 1.203-.043 1.512-.133.402-.117.707-.312.91-.586.203-.273.308-.617.308-1.027 0-.39-.097-.734-.289-1.027a1.44 1.44 0 00-.816-.61c-.355-.109-.96-.164-1.82-.164H6.285zm-1.59 6.809V81.102h4.496c.918 0 1.653.12 2.204.359.55.234.984.602 1.296 1.098a2.81 2.81 0 01.47 1.546c0 .5-.138.973-.415 1.418-.277.446-.695.801-1.258 1.075.727.207 1.282.562 1.672 1.062.387.504.582 1.098.582 1.781a3.36 3.36 0 01-.355 1.536c-.235.472-.528.835-.88 1.09-.347.257-.784.453-1.308.581-.527.133-1.172.196-1.933.196zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M21.277 88.578c-.535.211-1.336.395-2.402.543-.602.086-1.031.184-1.281.29-.25.1-.446.26-.578.468-.141.207-.207.433-.207.683 0 .383.148.708.445.961.297.258.73.383 1.3.383.567 0 1.075-.12 1.516-.363.442-.238.766-.574.973-.996.16-.324.234-.805.234-1.445zm.125 3.219c-.547.453-1.07.773-1.574.96a4.712 4.712 0 01-1.621.282c-.953 0-1.684-.23-2.2-.687-.51-.457-.769-1.036-.769-1.75 0-.415.098-.797.29-1.137.195-.348.445-.625.761-.832a3.675 3.675 0 011.059-.473c.289-.074.726-.148 1.304-.219 1.192-.136 2.063-.3 2.625-.496.004-.199.012-.32.012-.375 0-.59-.14-1.004-.418-1.242-.375-.328-.933-.488-1.676-.488-.691 0-1.203.12-1.535.355-.324.239-.574.66-.73 1.266l-1.434-.195c.129-.602.344-1.09.645-1.461.297-.375.73-.66 1.297-.86.566-.199 1.222-.3 1.968-.3.742 0 1.344.085 1.809.257.46.172.8.387 1.02.649.218.254.367.582.456.976.051.246.075.692.075 1.332v1.922c0 1.34.03 2.188.093 2.54.063.359.188.699.371 1.023h-1.535a2.987 2.987 0 01-.293-1.047"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M24.98 96.121l-.164-1.351c.325.085.602.125.84.125.328 0 .59-.051.785-.157.2-.105.36-.258.485-.449.094-.144.242-.504.453-1.074.023-.082.066-.195.129-.352L24.21 84.34h1.586l1.808 4.926c.235.625.442 1.28.63 1.968.167-.66.37-1.308.605-1.937l1.851-4.957h1.473l-3.3 8.648c-.356.938-.63 1.578-.829 1.93-.258.477-.558.824-.898 1.05-.336.22-.739.333-1.207.333-.285 0-.598-.063-.95-.18"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M34.527 87.773h4.844c-.062-.714-.25-1.25-.555-1.609-.468-.555-1.074-.832-1.824-.832-.672 0-1.242.219-1.703.664-.46.445-.715 1.035-.762 1.777m4.828 2.332l1.52.188c-.238.867-.684 1.543-1.332 2.023-.648.48-1.477.723-2.48.723-1.274 0-2.278-.383-3.024-1.148-.742-.766-1.113-1.84-1.113-3.227 0-1.434.375-2.539 1.125-3.332.754-.789 1.726-1.184 2.926-1.184 1.16 0 2.109.387 2.843 1.16.739.774 1.102 1.864 1.102 3.27 0 .082 0 .211-.008.383h-6.469c.055.934.325 1.648.809 2.144.484.497 1.086.747 1.812.747.54 0 1-.141 1.38-.418.382-.278.687-.72.91-1.329"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M42.707 92.844V84.34h1.324v1.289c.336-.606.645-1.004.934-1.192.285-.195.597-.289.945-.289.496 0 1 .157 1.512.465l-.512 1.336a2.084 2.084 0 00-1.074-.312c-.32 0-.613.093-.867.285a1.553 1.553 0 00-.547.785 5.532 5.532 0 00-.246 1.684v4.453zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M48.305 84.34h1.468v8.504h-1.468zm0-3.238h1.468v1.66h-1.468zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M51.426 90.305l1.453-.223c.082.574.309 1.008.684 1.316.37.305.894.454 1.562.454.676 0 1.18-.137 1.504-.403.332-.273.492-.586.492-.949 0-.328-.144-.586-.434-.77-.199-.125-.703-.293-1.503-.488-1.079-.27-1.825-.5-2.243-.695-.414-.195-.734-.465-.949-.809a2.095 2.095 0 01-.32-1.14c0-.38.086-.73.266-1.055a2.3 2.3 0 01.722-.805c.227-.164.54-.304.938-.418.39-.117.812-.172 1.27-.172.679 0 1.277.094 1.792.29.512.187.895.449 1.14.777.243.328.41.77.509 1.32l-1.442.192c-.066-.438-.254-.782-.566-1.024-.313-.246-.758-.371-1.328-.371-.676 0-1.16.11-1.45.328-.285.219-.43.477-.43.766 0 .191.06.36.177.508.125.156.308.28.566.386.144.051.578.172 1.3.368 1.04.273 1.766.496 2.176.667.415.172.735.426.97.758.234.332.35.742.35 1.235 0 .48-.14.933-.429 1.355-.285.426-.695.754-1.238.988-.54.23-1.149.348-1.828.348-1.13 0-1.989-.23-2.578-.687-.59-.461-.97-1.141-1.133-2.047"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M66.047 89.73l1.445.184c-.16.977-.562 1.742-1.215 2.293-.652.555-1.449.832-2.398.832-1.188 0-2.145-.379-2.863-1.14-.723-.762-1.082-1.856-1.082-3.274 0-.918.156-1.723.464-2.414a3.202 3.202 0 011.418-1.547 4.286 4.286 0 012.075-.516c.941 0 1.71.23 2.308.7.602.468.985 1.129 1.156 1.992l-1.43.215c-.14-.57-.382-1-.726-1.29-.344-.288-.765-.433-1.258-.433-.738 0-1.34.262-1.804.781-.461.52-.692 1.344-.692 2.469 0 1.145.223 1.977.668 2.496.45.516 1.032.774 1.75.774.578 0 1.063-.172 1.45-.52.382-.348.628-.879.734-1.602"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M68.75 92.844V81.102h1.469v4.214c.691-.78 1.554-1.168 2.601-1.168.64 0 1.2.122 1.676.372.473.25.809.59 1.016 1.027.203.437.308 1.074.308 1.906v5.39h-1.472v-5.39c0-.719-.16-1.246-.477-1.574-.32-.324-.773-.488-1.355-.488-.438 0-.844.109-1.23.332a1.88 1.88 0 00-.821.898c-.164.383-.246.902-.246 1.57v4.653zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M79.168 87.773h4.848c-.067-.714-.254-1.25-.555-1.609-.473-.555-1.078-.832-1.824-.832-.676 0-1.242.219-1.703.664-.461.445-.72 1.035-.766 1.777M84 90.105l1.52.188c-.243.867-.684 1.543-1.329 2.023-.656.48-1.48.723-2.488.723-1.273 0-2.273-.383-3.023-1.148-.743-.766-1.114-1.84-1.114-3.227 0-1.434.38-2.539 1.13-3.332.753-.789 1.726-1.184 2.925-1.184 1.16 0 2.11.387 2.844 1.16.734.774 1.105 1.864 1.105 3.27 0 .082-.007.211-.007.383h-6.477c.055.934.324 1.648.809 2.144.488.497 1.09.747 1.816.747.535 0 1-.141 1.379-.418.387-.278.683-.72.91-1.329"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M98.457 92.844V81.102h1.586V91.46h5.898v1.383zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M113.184 88.578c-.536.211-1.332.395-2.399.543-.61.086-1.035.184-1.289.29a1.252 1.252 0 00-.578.468 1.24 1.24 0 00-.203.683c0 .383.148.708.441.961.301.258.735.383 1.309.383.566 0 1.07-.12 1.508-.363.445-.238.765-.574.972-.996.16-.324.239-.805.239-1.445zm.12 3.219c-.546.453-1.066.773-1.57.96a4.696 4.696 0 01-1.62.282c-.958 0-1.688-.23-2.204-.687-.508-.457-.765-1.036-.765-1.75 0-.415.097-.797.293-1.137.19-.348.445-.625.757-.832a3.723 3.723 0 011.059-.473c.289-.074.726-.148 1.308-.219 1.188-.136 2.063-.3 2.622-.496.007-.199.007-.32.007-.375 0-.59-.136-1.004-.418-1.242-.375-.328-.933-.488-1.671-.488-.692 0-1.204.12-1.532.355-.332.239-.574.66-.734 1.266l-1.438-.195c.133-.602.348-1.09.645-1.461.3-.375.734-.66 1.3-.86.567-.199 1.223-.3 1.97-.3.742 0 1.343.085 1.808.257.461.172.805.387 1.02.649.218.254.37.582.457.976.05.246.074.692.074 1.332v1.922c0 1.34.031 2.188.094 2.54.062.359.187.699.37 1.023h-1.534a2.907 2.907 0 01-.297-1.047"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M116.953 92.844V84.34h1.32v1.207c.641-.93 1.563-1.399 2.766-1.399.523 0 1 .09 1.441.274.438.187.766.426.989.726.215.301.367.657.457 1.063.05.27.078.738.078 1.406v5.227h-1.469v-5.172c0-.59-.058-1.027-.172-1.317a1.41 1.41 0 00-.61-.699 1.988 1.988 0 00-1.026-.261c-.625 0-1.165.195-1.622.585-.457.391-.683 1.133-.683 2.22v4.644zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M127.242 88.602c0 1.09.23 1.902.7 2.441.468.539 1.023.809 1.66.809.644 0 1.191-.258 1.64-.774.45-.516.672-1.3.672-2.355 0-1.168-.226-2.02-.684-2.567-.46-.543-1.027-.816-1.695-.816-.652 0-1.2.258-1.637.785-.437.523-.656 1.348-.656 2.477m4.649 4.242v-1.07c-.551.843-1.36 1.265-2.426 1.265a3.457 3.457 0 01-1.91-.562 3.68 3.68 0 01-1.348-1.567c-.32-.668-.48-1.437-.48-2.308 0-.852.148-1.622.433-2.313.293-.691.723-1.219 1.3-1.59a3.5 3.5 0 011.935-.55c.527 0 .992.105 1.406.32.406.219.734.496.992.847v-4.214h1.46v11.742zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M136.68 87.773h4.84c-.067-.714-.247-1.25-.551-1.609-.469-.555-1.074-.832-1.824-.832-.672 0-1.239.219-1.7.664-.46.445-.718 1.035-.765 1.777m4.828 2.332l1.52.188c-.243.867-.684 1.543-1.333 2.023-.648.48-1.476.723-2.484.723-1.266 0-2.274-.383-3.02-1.148-.738-.766-1.113-1.84-1.113-3.227 0-1.434.375-2.539 1.129-3.332.75-.789 1.723-1.184 2.922-1.184 1.16 0 2.11.387 2.844 1.16.734.774 1.101 1.864 1.101 3.27 0 .082 0 .211-.008.383h-6.468c.054.934.324 1.648.808 2.144.485.497 1.09.747 1.813.747.539 0 1-.141 1.383-.418.378-.278.683-.72.906-1.329"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M144.281 90.305l1.457-.223c.078.574.309 1.008.684 1.316.371.305.894.454 1.562.454.672 0 1.176-.137 1.504-.403.328-.273.489-.586.489-.949 0-.328-.145-.586-.434-.77-.2-.125-.7-.293-1.5-.488-1.082-.27-1.828-.5-2.246-.695a2.206 2.206 0 01-.95-.809c-.21-.34-.32-.722-.32-1.14 0-.38.09-.73.266-1.055.18-.324.418-.59.723-.805.226-.164.539-.304.937-.418a4.433 4.433 0 011.27-.172c.68 0 1.277.094 1.797.29.511.187.89.449 1.136.777.242.328.414.77.508 1.32l-1.441.192c-.067-.438-.254-.782-.567-1.024-.312-.246-.754-.371-1.328-.371-.672 0-1.156.11-1.445.328-.29.219-.434.477-.434.766 0 .191.059.36.18.508.121.156.309.28.562.386.153.051.579.172 1.305.368 1.035.273 1.762.496 2.176.667.41.172.73.426.965.758.234.332.355.742.355 1.235 0 .48-.144.933-.433 1.355-.29.426-.7.754-1.239.988-.539.23-1.148.348-1.824.348-1.133 0-1.992-.23-2.582-.687-.59-.461-.969-1.141-1.133-2.047"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M158.777 88.578c-.535.211-1.336.395-2.398.543-.61.086-1.035.184-1.285.29a1.225 1.225 0 00-.785 1.151c0 .383.148.708.445.961.297.258.73.383 1.305.383.566 0 1.066-.12 1.511-.363.438-.238.766-.574.973-.996.156-.324.234-.805.234-1.445zm.121 3.219c-.543.453-1.066.773-1.57.96a4.712 4.712 0 01-1.621.282c-.957 0-1.687-.23-2.2-.687-.51-.457-.769-1.036-.769-1.75a2.372 2.372 0 011.05-1.969 3.699 3.699 0 011.056-.473c.293-.074.726-.148 1.308-.219 1.192-.136 2.063-.3 2.625-.496.008-.199.008-.32.008-.375 0-.59-.137-1.004-.418-1.242-.375-.328-.933-.488-1.676-.488-.691 0-1.199.12-1.527.355-.332.239-.578.66-.734 1.266l-1.438-.195c.13-.602.348-1.09.645-1.461.3-.375.734-.66 1.3-.86.567-.199 1.223-.3 1.97-.3.741 0 1.343.085 1.808.257.46.172.8.387 1.02.649.218.254.37.582.456.976.051.246.075.692.075 1.332v1.922c0 1.34.027 2.188.093 2.54.063.359.188.699.371 1.023h-1.539a3.072 3.072 0 01-.293-1.047"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M163.879 88.64c0 1.098.223 1.903.676 2.426.453.524 1 .786 1.644.786.653 0 1.211-.27 1.68-.813.46-.543.695-1.383.695-2.52 0-1.082-.226-1.894-.683-2.433-.45-.54-.996-.809-1.63-.809-.624 0-1.179.285-1.66.86-.484.574-.722 1.41-.722 2.504m-1.332 7.468V84.34h1.34v1.102c.316-.43.672-.754 1.07-.972.398-.215.879-.32 1.445-.32.739 0 1.395.183 1.961.558.567.371.996.902 1.285 1.582.286.68.43 1.426.43 2.238 0 .871-.16 1.657-.476 2.352-.32.7-.782 1.23-1.391 1.605a3.635 3.635 0 01-1.914.555c-.492 0-.93-.102-1.32-.305-.391-.203-.711-.46-.961-.77v4.145zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M172.82 88.59c0 1.094.239 1.906.727 2.45.484.542 1.094.812 1.832.812a2.33 2.33 0 001.82-.817c.485-.543.727-1.375.727-2.492 0-1.05-.246-1.848-.73-2.39a2.348 2.348 0 00-1.817-.813c-.738 0-1.348.27-1.832.808-.488.54-.727 1.352-.727 2.442m-1.515 0c0-1.57.449-2.738 1.34-3.5.746-.63 1.656-.942 2.734-.942 1.187 0 2.164.383 2.922 1.145.758.77 1.137 1.828 1.137 3.18 0 1.097-.172 1.957-.504 2.582a3.52 3.52 0 01-1.461 1.465c-.641.343-1.34.52-2.094.52-1.219 0-2.2-.384-2.95-1.15-.75-.757-1.124-1.863-1.124-3.3"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M184.375 91.559l.21 1.27a5.538 5.538 0 01-1.112.128c-.532 0-.946-.082-1.243-.246-.289-.168-.5-.383-.617-.652-.125-.274-.18-.84-.18-1.704v-4.894h-1.081V84.34h1.082v-2.11l1.46-.863v2.973h1.481v1.12h-1.48v4.978c0 .41.023.675.074.789.05.117.14.21.258.28.113.071.285.106.5.106.164 0 .378-.02.648-.054"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M185.813 92.844V81.102h1.468v4.214c.688-.78 1.555-1.168 2.602-1.168.64 0 1.199.122 1.676.372.472.25.808.59 1.015 1.027.203.437.305 1.074.305 1.906v5.39h-1.469v-5.39c0-.719-.16-1.246-.48-1.574-.317-.324-.77-.488-1.352-.488-.433 0-.844.109-1.23.332a1.88 1.88 0 00-.82.898c-.165.383-.247.902-.247 1.57v4.653zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M196.23 87.773h4.848c-.066-.714-.254-1.25-.558-1.609-.47-.555-1.075-.832-1.825-.832-.672 0-1.242.219-1.703.664-.457.445-.715 1.035-.762 1.777m4.833 2.332l1.515.188c-.238.867-.683 1.543-1.332 2.023-.644.48-1.473.723-2.48.723-1.274 0-2.278-.383-3.02-1.148-.746-.766-1.117-1.84-1.117-3.227 0-1.434.375-2.539 1.129-3.332.75-.789 1.726-1.184 2.926-1.184 1.16 0 2.105.387 2.843 1.16.735.774 1.102 1.864 1.102 3.27 0 .082 0 .211-.008.383h-6.469c.051.934.32 1.648.805 2.144.488.497 1.09.747 1.816.747.54 0 1-.141 1.38-.418.378-.278.687-.72.91-1.329"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M204.434 92.844V81.102h1.472v6.695l3.48-3.457h1.907l-3.32 3.152 3.652 5.352h-1.813l-2.87-4.348-1.036.977v3.37zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M213.906 87.773h4.848c-.066-.714-.25-1.25-.559-1.609-.468-.555-1.078-.832-1.82-.832-.672 0-1.246.219-1.707.664-.457.445-.715 1.035-.762 1.777m4.832 2.332l1.516.188c-.238.867-.684 1.543-1.328 2.023-.653.48-1.48.723-2.488.723-1.266 0-2.274-.383-3.02-1.148-.742-.766-1.113-1.84-1.113-3.227 0-1.434.375-2.539 1.129-3.332.75-.789 1.726-1.184 2.925-1.184 1.16 0 2.106.387 2.84 1.16.738.774 1.106 1.864 1.106 3.27 0 .082-.004.211-.008.383h-6.473c.055.934.328 1.648.809 2.144.484.497 1.09.747 1.816.747.54 0 .996-.141 1.38-.418.382-.278.687-.72.91-1.329"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M222.086 92.844V84.34h1.328v1.289c.336-.606.645-1.004.934-1.192.285-.195.601-.289.941-.289.492 0 1 .157 1.512.465l-.508 1.336a2.087 2.087 0 00-1.078-.312c-.32 0-.61.093-.863.285-.258.187-.438.453-.551.785a5.655 5.655 0 00-.246 1.684v4.453zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M227.684 92.844V81.102h1.472v6.695l3.48-3.457h1.907l-3.32 3.152 3.652 5.352h-1.813l-2.867-4.348-1.039.977v3.37zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M241.586 88.578c-.531.211-1.332.395-2.402.543-.606.086-1.032.184-1.286.29a1.214 1.214 0 00-.578.468 1.21 1.21 0 00-.203.683c0 .383.149.708.442.961.3.258.73.383 1.304.383.57 0 1.07-.12 1.512-.363.445-.238.766-.574.973-.996.16-.324.238-.805.238-1.445zm.125 3.219c-.547.453-1.07.773-1.578.96a4.696 4.696 0 01-1.621.282c-.953 0-1.688-.23-2.196-.687-.511-.457-.77-1.036-.77-1.75 0-.415.095-.797.29-1.137.195-.348.45-.625.762-.832a3.675 3.675 0 011.058-.473c.29-.074.723-.148 1.305-.219 1.184-.136 2.062-.3 2.625-.496.004-.199.008-.32.008-.375 0-.59-.14-1.004-.418-1.242-.375-.328-.938-.488-1.676-.488-.691 0-1.2.12-1.531.355-.328.239-.574.66-.73 1.266l-1.438-.195c.129-.602.344-1.09.644-1.461.297-.375.73-.66 1.301-.86.566-.199 1.223-.3 1.965-.3.746 0 1.348.085 1.809.257.46.172.808.387 1.023.649.215.254.371.582.453.976.05.246.074.692.074 1.332v1.922c0 1.34.035 2.188.094 2.54.063.359.191.699.375 1.023h-1.535a2.906 2.906 0 01-.293-1.047"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M245.352 92.844V84.34h1.316v1.191a3.1 3.1 0 011.09-1.004c.449-.254.965-.379 1.543-.379.64 0 1.168.13 1.582.391.41.262.699.629.867 1.098.684-.992 1.582-1.489 2.684-1.489.859 0 1.52.23 1.984.7.465.468.691 1.187.691 2.16v5.836h-1.457v-5.356c0-.578-.047-.996-.148-1.246a1.207 1.207 0 00-.516-.613 1.637 1.637 0 00-.883-.234c-.609 0-1.117.199-1.52.597-.401.399-.605 1.035-.605 1.914v4.938h-1.468V87.32c0-.644-.121-1.125-.364-1.445-.238-.316-.632-.48-1.175-.48-.414 0-.797.105-1.145.324-.355.21-.61.523-.77.937-.16.41-.234 1-.234 1.774v4.414zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M259.297 92.844V84.34h1.316v1.191c.27-.414.633-.75 1.082-1.004.453-.254.97-.379 1.547-.379.64 0 1.164.13 1.578.391.414.262.703.629.875 1.098.684-.992 1.578-1.489 2.676-1.489.863 0 1.524.23 1.988.7.461.468.696 1.187.696 2.16v5.836h-1.465v-5.356c0-.578-.047-.996-.14-1.246a1.234 1.234 0 00-.52-.613 1.637 1.637 0 00-.883-.234c-.61 0-1.117.199-1.524.597-.402.399-.605 1.035-.605 1.914v4.938h-1.465V87.32c0-.644-.121-1.125-.363-1.445-.238-.316-.633-.48-1.176-.48-.414 0-.797.105-1.144.324-.352.21-.614.523-.77.937-.156.41-.234 1-.234 1.774v4.414zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M274.348 87.773h4.843c-.066-.714-.25-1.25-.554-1.609-.469-.555-1.075-.832-1.82-.832-.68 0-1.247.219-1.704.664-.465.445-.718 1.035-.765 1.777m4.828 2.332l1.52.188c-.239.867-.684 1.543-1.333 2.023-.644.48-1.476.723-2.484.723-1.27 0-2.274-.383-3.02-1.148-.742-.766-1.117-1.84-1.117-3.227 0-1.434.38-2.539 1.13-3.332.753-.789 1.73-1.184 2.925-1.184 1.16 0 2.113.387 2.848 1.16.73.774 1.101 1.864 1.101 3.27 0 .082-.004.211-.008.383h-6.472c.054.934.324 1.648.808 2.144.485.497 1.094.747 1.813.747.539 0 1-.141 1.383-.418.378-.278.683-.72.906-1.329"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M282.527 92.844V84.34h1.32v1.289c.34-.606.653-1.004.942-1.192.281-.195.598-.289.941-.289.497 0 1 .157 1.512.465l-.508 1.336a2.108 2.108 0 00-1.078-.312c-.32 0-.61.093-.867.285-.254.187-.434.453-.547.785a5.655 5.655 0 00-.246 1.684v4.453zm0 0"
        ></path>
        <path
          fill="#FFF"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M287.23 75.48H4.695v-1.125H287.23zm0 0"
        ></path>
        <path
          fill="#009FE3"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M101.492 15.668v44.781h27.754v-8.285h-19.125V15.668zm0 0"
        ></path>
        <path
          fill="#009FE3"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M202.438 15.668l-15.336 18.57v-18.57h-8.625v44.781h8.625V46.031l4.949-5.71 11.816 20.128H214.7l-16.816-27.086 15.328-17.695zm0 0"
        ></path>
        <path
          fill="#009FE3"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M71.844 40.508h9.402c3.684 0 6.207 1.816 6.207 6.398 0 4.637-2.965 5.895-6.371 5.895h-9.238zm-8.625 19.941h19.015c7.09 0 13.856-3.886 13.856-12.976 0-5.582-2.422-9.782-7.207-11.352 3.41-1.883 5.332-4.957 5.332-9.344 0-8.347-5.055-11.109-12.528-11.109H63.22zm8.625-37.129h8.078c3.082 0 5.941.887 5.941 5.153 0 3.757-2.254 5.324-5.277 5.324h-8.742zm0 0"
        ></path>
        <path
          fill="#009FE3"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M134.652 60.453h8.739l3.074-9.973h14.676l2.968 9.973h8.961l-14.68-44.785h-8.847zm19.18-33.734h.106l4.949 16.422h-10.168zm0 0"
        ></path>
      </g>
      <path
        fill="#009ee3"
        strokeWidth="0.75"
        d="M15.925 37.15l12.833 4.348 5.72 12.112-12.927-4.44z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.285"
        d="M37.132 68.313c-4.426-1.524-8.16-2.895-8.297-3.047-.265-.292-7.171-15.03-7.171-15.302 0-.22 16.184 5.3 16.518 5.635.149.149 1.7 3.284 3.447 6.969 3.851 8.12 4.044 8.555 3.768 8.534-.12-.01-3.839-1.264-8.265-2.789z"
        transform="scale(.75)"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.285"
        d="M36.988 68.299c-4.348-1.518-8.02-2.883-8.16-3.034-.28-.302-6.73-14.035-7.019-14.944-.155-.49.918-.193 7.89 2.178 4.438 1.51 8.225 2.885 8.415 3.057.297.268 6.508 13.093 7.227 14.922.18.456.152.632-.097.61-.192-.017-3.907-1.272-8.256-2.79z"
        transform="scale(.75)"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M24.076 29.016l5.49 11.626 11.86 4.078-5.509-11.606z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M28.389 63.718l1.039 2.196 5.313-.02z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M36.545 55.425l5.058 10.744 6.96-6.646z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M43.446 46.524l4.94 10.47.118-8.745z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M48.514 36.261l.09-2.14-4.527-9.639-10.608-3.649h-2.275l5.405 11.352z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M48.31 21.802l.023 2.973-3.446-1.126-.945-1.847z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M22.072 27.275l-2.567-5.45-10.609-.023v.923z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M13.851 35.293l-4.955-1.69v-8.806z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M20.766 50.045l5.63 11.937-12.905-4.37L8.446 46.87l.022-1.058z"
      ></path>
      <path
        fill="#009ee3"
        fillOpacity="1"
        strokeWidth="0.75"
        d="M12.725 58.266l-4.392-1.442 2.726 6.217 5.18 2.747z"
      ></path>
    </svg>
  );
}

export default Icon;
